import React from 'react';

import { TaskPositionType } from '../types';

interface ICalendarTaskBodyCaption {
    task: TaskPositionType;
}

const CalendarTaskBodyCaption: React.FC<ICalendarTaskBodyCaption> = ({ task }) => {
    return (
        <div
            style={{
                fontWeight: 'bold',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                fontSize: 12,
            }}
        >
            {task.name}
        </div>
    );
};

export default CalendarTaskBodyCaption;
